import { http, HttpResponse } from 'msw';
import { inoutTransactionsList } from '../data/transactions/inout-transactions-list';

export const transactionsHandlers = [
  http.get('**/api/**/transactions/InOut', () => {
    return HttpResponse.json(inoutTransactionsList);
  })
];
